import React from 'react';
import { Droplets, Wind, Package } from 'lucide-react';

const Products = () => {
  const products = [
    {
      icon: Droplets,
      name: 'Juice Powder',
      description: 'Premium mandarin juice powder with exceptional solubility and natural flavor retention. Perfect for beverages, supplements, and food applications.',
      features: ['100% Natural', 'High Solubility', 'Rich Flavor', 'Long Shelf Life'],
      gradient: 'from-orange-500 to-orange-600'
    },
    {
      icon: Wind,
      name: 'Mandarin Aroma',
      description: 'Concentrated mandarin aroma extracted through advanced distillation. Captures the authentic essence of fresh Croatian mandarins.',
      features: ['Pure Extract', 'Intense Aroma', 'Versatile Use', 'Food Grade'],
      gradient: 'from-blue-500 to-blue-600'
    },
    {
      icon: Package,
      name: 'Mandarin Pellets',
      description: 'High-quality mandarin pellets processed from mandarin residue. Ideal for animal feed, biofuel, and industrial applications.',
      features: ['Sustainable', 'High Energy', 'Consistent Quality', 'Eco-Friendly'],
      gradient: 'from-green-500 to-green-600'
    }
  ];

  return (
    <section id="products" className="py-24 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-blue-100 rounded-full mb-4">
            <span className="text-sm font-semibold text-blue-700">Our Products</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Premium Mandarin Solutions
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Discover our range of high-quality mandarin processing products, crafted for excellence in every application.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {products.map((product, index) => {
            const Icon = product.icon;
            return (
              <div key={index} className="group relative">
                {/* Card */}
                <div className="relative h-full bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all border border-gray-100 overflow-hidden">
                  {/* Gradient Header */}
                  <div className={`h-2 bg-gradient-to-r ${product.gradient}`}></div>
                  
                  <div className="p-8">
                    {/* Icon */}
                    <div className={`w-16 h-16 bg-gradient-to-br ${product.gradient} rounded-2xl flex items-center justify-center mb-6 shadow-lg group-hover:scale-110 transition-transform`}>
                      <Icon className="w-8 h-8 text-white" />
                    </div>

                    {/* Content */}
                    <h3 className="text-2xl font-bold text-gray-900 mb-4">{product.name}</h3>
                    <p className="text-gray-600 mb-6 leading-relaxed">{product.description}</p>

                    {/* Features */}
                    <div className="space-y-3">
                      {product.features.map((feature, idx) => (
                        <div key={idx} className="flex items-center gap-2">
                          <div className={`w-1.5 h-1.5 rounded-full bg-gradient-to-r ${product.gradient}`}></div>
                          <span className="text-sm text-gray-700 font-medium">{feature}</span>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Hover Effect Border */}
                  <div className={`absolute inset-0 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none`}>
                    <div className={`absolute inset-0 rounded-2xl border-2 bg-gradient-to-r ${product.gradient} opacity-20`}></div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Bottom CTA */}
        <div className="mt-16 text-center">
          <p className="text-gray-600 mb-6">Interested in our products? Get in touch for samples and specifications.</p>
          <button
            onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
            className="px-8 py-4 bg-gradient-to-r from-orange-500 to-orange-600 text-white rounded-xl font-semibold hover:from-orange-600 hover:to-orange-700 transition-all shadow-lg hover:shadow-xl"
          >
            Request Information
          </button>
        </div>
      </div>
    </section>
  );
};

export default Products;